"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Header;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

/**
 * Header used as the first child of a Criteria component.
 *
 * @displayName Header
 *
 * @param {Object} props Props
 * @returns {ReactElement} ReactElement
 */
function Header(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "ux-criteria-header title extra-small"
  }, props.children);
}
/**
 * PropType validation.
 *
 * @type {Object}
 * @private
 */


Header.propTypes = {
  /** The child elements */
  children: _propTypes.default.node
};